<template>
  <el-dialog class="modal-loading" :visible.sync="visible" :mask-closable="false" :closable="progress==100" width="600px">
    <!-- <div class="circleProgress_wrapper">
      <div class="num">{{progress}}%</div>
      <div class="wrapper right">
          <div class="circleProgress rightcircle" :style="rightDeg"></div>
      </div>
      <div class="wrapper left">
          <div class="circleProgress leftcircle" :style="leftDeg"></div>
      </div>
    </div> -->
    <el-progress type="circle" :percentage="progress" :color="progress==100?'#22BC02':'#F47900'" :width="120"
      :status="progress==100?'success':null"></el-progress>
    <div class="title-text">{{title}}</div>
    <div class="info-text" v-html="content"></div>
  </el-dialog>
</template>
<script>
export default {
  props:{},
  name:"modalLoading",
  data() {
    return {
      size: 2,
      title:"",
      content:"",
      visible:false,//显示
      progress:100,
    };
  },
  computed:{
    rightDeg(){
      if(this.progress>=50){
        return {transform: "rotate(225deg)"};
      }else{
        return {transform: "rotate("+((225-45)/50*this.progress+45)+"deg)"};
      }
    },
    leftDeg(){
      if(this.progress<=50){
        return {transform: "rotate(45deg)"};
      }else{
        return {transform: "rotate("+((225-45)/50*(this.progress-50)+45)+"deg)"};
      }
    }
  },
  mounted() {
    // this.autoPlay();
  },
  methods:{
    setText(data){
      if(data.title){
        this.title = data.title;
      }
      if(data.size){
        this.size = data.size;
      }
      if(data.content){
        this.content = data.content;
      }
      if(data.progress){
        this.progress = data.progress;
      }
    },
    close(){
      this.visible = false;
    },
    open(data){
      this.visible = true;
      this.progress=0;
      this.autoPlay();
      this.setText(data);
    },
    autoPlay(){
      const size = this.size;
      setTimeout(()=>{
        if(this.visible == false||this.progress>=99){
          return;
        }
        if(this.progress+size>99){
          this.progress = 99;
          return;
        }
        this.progress=this.progress+size;
        this.autoPlay();
      },1000)
    },
    ok(){
      this.progress = 100;
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./modalLoading.scss";
</style>
